import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { ILogin } from './../../interfaces/Ilogin'
import * as UserService from './../../services/User.service'
import * as LanguageService from './../../services/Language.service'
import * as SG from '../../style/Styles'
import * as S from '../../style/Login'
import * as TXT from './../../util/Texts'
import * as U from './../../util/UrlHttp'
import { ERROR_ALERT, SUCCESS_ALERT, SUCCESS_INFO } from './../../util/AlertsMsg'
import * as C from './../../util/Colors'

import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'

interface ChangePass {
  id:string|number,
  password:string
}

const backgrounStyle = {backgroundImage:`url(${U.ICON_BACK}),linear-gradient(${C.SECONDARY}, ${C.PRIMARY})`}

export default function Login() {

  const navigate                        = useNavigate()
  const [register, setRegister]         = useState<string>('')
  const [password, setPassword]         = useState<string>('')
  const [open, setOpen]                 = useState(false)
  const [newPass, setNewPass]           = useState<string>('')
  const [checkNewPass, setCheckNewPass] = useState<string>('')
  const [dataUser, setDataUser]         = useState<any>()
  const [typeInp, setTypeInp]           = useState<string>('password')
  const [iconPass, setIconPass]         = useState<string>('fa-eye')

  const [langs, setLangs]               = useState<any[]>([])
  const [selectedLang, setSelectedLang] = useState<any>(null)
  const [openLangModal, setOpenLangModal] = useState(false)

  const handleSend = async () => {

    if (register.trim() === '' || password.trim() === '') {
      ERROR_ALERT(TXT.LOGIN_AND_PASS)
      return
    }

    const data:ILogin = {register, password}

    try {

      const result = await UserService.Login(data)

      if (result.data) {

        if (result.status === 200) {

          setDataUser(result.data)
  
          if (register.trim() === password.trim()) {
            setOpen(true)
            return
          }

          goHome(result.data)

        } else {
          ERROR_ALERT(result.data.message)
        }

      } else {
        ERROR_ALERT(TXT.LOGIN_OR_PASS)
      }

    } catch (error) {
      ERROR_ALERT(TXT.WRONG_TRY_AGAIN)
    }
    
    return
  }

  const openEye = () => {

    setIconPass(iconPass === 'fa-eye-slash' ? 'fa-eye' : 'fa-eye-slash')
    setTypeInp(typeInp === 'password' ? 'text' : 'password')

  }

  const goHome = (data:any) => {

    let getData = dataUser

    if (data !== null)
      getData = data

    localStorage.setItem('us_tk', getData.access_token)
    localStorage.setItem('us_id', getData.id)
    localStorage.setItem('us_nm', getData.name)
    localStorage.setItem('us_re', getData.register)
    localStorage.setItem('us_profID', getData.profID)
    localStorage.setItem('us_dpt', getData.department ?? '')
    localStorage.setItem('us_cs', getData.cs ?? '')
    localStorage.setItem('us_country_id', getData.country_id ?? '')

    setTimeout(()=>{
      window.location.reload()
    },200)

    navigate(`/dashboard`)
    
  }

  const showInfoPass = () => {
    SUCCESS_INFO(TXT.MSG_FORGOT_PASS)
  }

  const saveNewPass = async () => {

    let np  = newPass.replace(/ /g, "")
    let cnp = checkNewPass.replace(/ /g, "")

    if (np.trim().length < 5) {
      ERROR_ALERT(TXT.MIN_CHAR_PASS)
      return false
    }

    if (register.trim() === np) {
      ERROR_ALERT(TXT.NOT_CAN_EQUAL)
      return
    }

    if (np !== cnp) {
      ERROR_ALERT(TXT.WRONG_CONFIRM)
      return false
    }

    try {

      const data:ChangePass = {id:dataUser.id, password: np}
      const result          = await UserService.ChangePassword(data, dataUser.access_token)

      if (result.data) {

        if (result.status === 200){
          SUCCESS_ALERT(result.data.message)
          setTimeout(()=>{
            goHome(null)
          }, 2000)
        }
        else
          ERROR_ALERT(result.data.message)
          setTimeout(()=>{
            window.location.reload()
          },3000)
      } 

    } catch (error) {

      console.warn(error)
      ERROR_ALERT(TXT.WRONG_TRY_AGAIN)

    }

    return
  }

  const getUniqueLanguages = (languagesList: any[]) => {
    if (!languagesList || !Array.isArray(languagesList)) return [];
    return languagesList.filter((v: any, i: number, a: any[]) => 
      a.findIndex((t: any) => t.id === v.id || t.name_lang.toLowerCase() === v.name_lang.toLowerCase()) === i
    );
  }

  const initializeLanguage = async (languagesList: any[]) => {
    const storedLang = localStorage.getItem('selected_language')
    let currentLang = null
    if (storedLang) {
      currentLang = JSON.parse(storedLang)
      setSelectedLang(currentLang)
    } else {
      const ptLang = languagesList.find((l: any) => 
        l.name_lang.toLowerCase().includes('portugues') || 
        l.name_lang.toLowerCase().includes('português') ||
        l.name_lang.toLowerCase().includes('brasil')
      )
      const defaultLang = ptLang || languagesList[0]
      if (defaultLang) {
        currentLang = defaultLang
        setSelectedLang(defaultLang)
        localStorage.setItem('selected_language', JSON.stringify(defaultLang))
      }
    }

    if (currentLang && !localStorage.getItem('selected_language_texts')) {
      try {
        const result = await LanguageService.GetLanguage(currentLang.id)
        if (result.data && result.data.status && result.data.language.texts) {
          localStorage.setItem('selected_language_texts', JSON.stringify(result.data.language.texts))
          window.location.reload()
        }
      } catch (err) {
        console.warn('Erro ao inicializar textos do idioma:', err)
      }
    }
  }

  const handleSelectLang = async (lang: any) => {
    setSelectedLang(lang)
    localStorage.setItem('selected_language', JSON.stringify(lang))
    
    try {
      const result = await LanguageService.GetLanguage(lang.id)
      if (result.data && result.data.status && result.data.language.texts) {
        localStorage.setItem('selected_language_texts', JSON.stringify(result.data.language.texts))
      } else {
        localStorage.removeItem('selected_language_texts')
      }
    } catch (err) {
      console.warn('Erro ao carregar traduções do idioma selecionado:', err)
      localStorage.removeItem('selected_language_texts')
    }

    setOpenLangModal(false)
    window.location.reload()
  }

  useEffect( () => {

    const us_tk:string|null = localStorage.getItem('us_tk')
  
    if (us_tk) {
      navigate(`/dashboard`)
    }

    const loadConfig = async () => {
      try {
        const result = await UserService.GetConfig()
        if (result && result.data && result.data.status) {
          localStorage.setItem('app_countries', JSON.stringify(result.data.countries))
          localStorage.setItem('app_languages', JSON.stringify(result.data.languages))
          const unique = getUniqueLanguages(result.data.languages)
          setLangs(unique)
          initializeLanguage(unique)
        } else {
          const storedLangs = localStorage.getItem('app_languages')
          if (storedLangs) {
            const parsed = JSON.parse(storedLangs)
            const unique = getUniqueLanguages(parsed)
            setLangs(unique)
            initializeLanguage(unique)
          }
        }
      } catch (error) {
        console.warn('Erro ao carregar configurações de países/idiomas:', error)
        const storedLangs = localStorage.getItem('app_languages')
        if (storedLangs) {
          const parsed = JSON.parse(storedLangs)
          const unique = getUniqueLanguages(parsed)
          setLangs(unique)
          initializeLanguage(unique)
        }
      }
    }
    loadConfig()

  }, []);

  return (

    <S.ContainerDegrade style={backgrounStyle}>

      <S.Lang onClick={() => setOpenLangModal(true)}>
        {selectedLang ? (
          <>
            <img 
              src={`${selectedLang.icon}`} 
              alt={selectedLang.name_lang} 
              onError={(e)=>{
                e.currentTarget.src = `${U.BASE_BACK + U.ICON_BR}`; 
              }}
              style={{ width: 24, height: 16, marginRight: 8, objectFit: 'cover', borderRadius: 2, border: '1px solid rgba(255,255,255,0.3)' }}
            />
            {selectedLang.name_lang}
          </>
        ) : (
          TXT.LANGUAGE
        )}
      </S.Lang>

      <S.BoxForm style={{flex:6, maxWidth:'100%'}}>

        <SG.LogoCopa className='iconLogoCopa' src={U.LOGO_COPA} alt="Copa"/>

        <S.Input 
          name='register'
          value={register}
          placeholder={TXT.LOGIN_PLACE}
          onChange={(e)=>{setRegister(e.target.value)}}
          onKeyPress={(e) => { if (e.key === "Enter") handleSend() }}
          style={{textAlign:'center'}}
          className='input'
        />
        
        <SG.Div className='cttpass'>
          <S.Input 
            type={typeInp}
            name='password'
            value={password}
            placeholder={TXT.PASS_PLACE}
            onChange={(e)=>{setPassword(e.target.value)}}
            onKeyPress={(e) => { if (e.key === "Enter") handleSend() }}
            style={{textAlign:'center'}}
            className='inputPass input'
          />
          <SG.Span className='IconPass' onClick={openEye}><SG.I className={`fa-solid ${iconPass}`}></SG.I></SG.Span> 
        </SG.Div>

        <S.BoxBtn>
          <SG.PrimaryButtom onClick={handleSend}>
            {TXT.ACCESS}
          </SG.PrimaryButtom>
        </S.BoxBtn>

        <SG.Text onClick={showInfoPass} className='ForgetPassTxt'>{TXT.FORGOT_PASS}</SG.Text>
      
      </S.BoxForm>

      <S.InfosLogin>
        <SG.LogoKnauf src={U.LOGO_KNAUF} alt="Knauf"/>
        <SG.Text onClick={()=>window.open('/regulaments','_blank')} className='regulamentTxt'>{TXT.CHECK_REGULAMENT}</SG.Text>
      </S.InfosLogin>

      <Dialog open={open}>
        <DialogTitle className='titleAlertChangePass'>{TXT.ATTENTION}</DialogTitle>
        <DialogContent>
          <DialogContentText className='dialogText'>{TXT.TXT_FORGOT_PASS}</DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="newPass"
            label={TXT.TXT_NEW_PASS}
            type="text"
            fullWidth
            variant="standard"
            onChange={(e)=>{setNewPass(e.target.value)}}
          />

          <TextField
            margin="dense"
            id="newPassConfirm"
            label={TXT.TXT_CONFIRM_NEW}
            type="text"
            fullWidth
            variant="standard"
            onChange={(e)=>{setCheckNewPass(e.target.value)}}
          />

        </DialogContent>

        <DialogActions>
          <Button className='btnDialog' onClick={saveNewPass}>{TXT.SAVE}</Button>
        </DialogActions>

      </Dialog>

      <Dialog 
        open={openLangModal} 
        onClose={() => setOpenLangModal(false)}
        PaperProps={{
          style: {
            borderRadius: 16,
            padding: '15px 10px',
            width: 480,
            maxWidth: '95vw'
          }
        }}
      >
        <DialogTitle style={{ fontWeight: 'bold', textAlign: 'center', paddingBottom: 15, fontSize: 18 }}>
          {TXT.SELECT_LANGUAGE}
        </DialogTitle>
        <DialogContent style={{ paddingTop: 10 }}>
          <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: 15, justifyContent: 'center' }}>
            {langs.length > 0 ? (
              langs.map((l: any) => (
                <div
                  key={l.id}
                  onClick={() => handleSelectLang(l)}
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '12px 8px',
                    borderRadius: 12,
                    cursor: 'pointer',
                    width: 'calc(25% - 12px)',
                    boxSizing: 'border-box',
                    backgroundColor: selectedLang?.id === l.id ? 'rgba(25, 112, 210, 0.08)' : 'transparent',
                    transition: 'all 0.2s ease',
                    border: selectedLang?.id === l.id ? '2px solid #1976d2' : '2px solid transparent'
                  }}
                  onMouseEnter={(e) => {
                    if (selectedLang?.id !== l.id) {
                      e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.03)';
                      e.currentTarget.style.transform = 'translateY(-2px)';
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (selectedLang?.id !== l.id) {
                      e.currentTarget.style.backgroundColor = 'transparent';
                      e.currentTarget.style.transform = 'none';
                    }
                  }}
                >
                  <img
                    src={`${l.icon}`}
                    alt={l.name_lang}
                    onError={(e) => {
                      e.currentTarget.src = `${U.BASE_BACK + U.ICON_BR}`;
                    }}
                    style={{ width: 40, height: 26, marginBottom: 8, objectFit: 'cover', borderRadius: 4, border: '1px solid #ddd', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}
                  />
                  <span style={{ fontSize: 12, fontWeight: selectedLang?.id === l.id ? 'bold' : 'normal', textAlign: 'center', color: '#333' }}>
                    {l.name_lang}
                  </span>
                </div>
              ))
            ) : (
              <div style={{ textAlign: 'center', padding: 20 }}>{TXT.LOADING_LANGUAGES}</div>
            )}
          </div>
        </DialogContent>
      </Dialog>

    </S.ContainerDegrade>

  );
}
  
  